import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { api } from '../../../static/api';
import { ApiAddQuestionRequest } from '../../../types/ApiTypes';
import { QueryAliases } from '../../../types/QueryAliases';
import { CallbackDefault } from '../../../types/Types';
import { getApiErrorMessage } from '../../../utils/api/getApiErrorMessage';
import useAxiosInstance from '../../axios/useAxiosInstance';
import useToast from '../../useToast';

const useUpdateRelatedQuestion = ({ onSuccess }: { onSuccess?: CallbackDefault } = {}) => {
  const axiosInstance = useAxiosInstance();
  const { t } = useTranslation();
  const { showErrorToast } = useToast();
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    ({ parentQuestionId, data }: { parentQuestionId: string; data: { relatedQuestion: ApiAddQuestionRequest } }) =>
      axiosInstance.patch(api.endpoints.SINGLE_QUESTION({ id: parentQuestionId }), { ...data }),
    {
      async onSuccess() {
        await queryClient.refetchQueries([QueryAliases.QUESTIONS]);

        if (!!onSuccess) {
          onSuccess();
        }
      },
      onError: (err: AxiosError) => {
        const errorMessage = getApiErrorMessage(err) ?? t('errorMessages.editQuestionFailed');

        showErrorToast(errorMessage);
      },
    },
  );

  return { updateRelatedQuestion: mutateAsync, isLoading };
};

export default useUpdateRelatedQuestion;
